import { useTranslation } from 'react-i18next'
import styles from './index.module.less'
import classNames from 'classnames'
import { getTransactionType, handleAddressJump } from '../../utils'
import { ugagToGag, ugeaToGea2 } from '@/utils/number'
import { cutStr, getFormatTimeZone, isEmptyOrNil } from '@/utils'
import { memo, useEffect, useMemo, useState } from 'react'
import useMeNavigate from '@/hooks/useMeNavigate'
import AddressHash from '@/components/AddressHash'
import { useParams } from 'react-router-dom'
import { useGlobalStore } from '@/hoxStore/globalStore'

interface IProps {
  tag: string // 类型
  from_address: string // 从
  to_address: string // 到
  amount: string // 数量
  height: number // 区块高度
  timestamp: number | string // 时间戳
}
const CoduleAccountTrading = (props: IProps) => {
  const { curReponsive } = useGlobalStore()
  const types = getTransactionType('ModuleAddressType')
  const navigate = useMeNavigate()
  const { t } = useTranslation()
  const { timeUtc0 = '-', currentTime = '-' } = getFormatTimeZone(props?.timestamp)
  const params = useParams()

  const [gagAmount, setGagAmount] = useState<{
    value: string
    sigin: string
  }>({
    value: '-',
    sigin: '',
  })
  const [geaAmount, setGeaAmount] = useState<{
    value: string
    sigin: string
  }>({
    value: '-',
    sigin: '',
  })

  const getGag = () => {
    const str = props?.amount?.split(',')
    setGagAmount({
      value: '-',
      sigin: '',
    })
    setGeaAmount({
      value: '-',
      sigin: '',
    })
    if (isEmptyOrNil(str)) return
    str.forEach((item) => {
      if (item.includes('ugag')) {
        setGagAmount(ugagToGag(item))
      } else {
        setGeaAmount(ugeaToGea2(item))
      }
    })
  }
  useEffect(() => {
    getGag()
  }, [props])

  const getTag = (tag: string) => {
    let key = ''
    const item = types.pageKeyList.find((item) => {
      let newKey: string = item.key
      if (newKey.endsWith('%s')) {
        newKey = newKey.replace('%s', '')
        key = newKey
      }
      if (tag?.startsWith(newKey)) {
        return true
      }
      if (tag === 'gov_operation' && newKey === 'transfer_in_abci') {
        return true
      }
      key = newKey
      return item.key === tag
    })
    let region = tag.slice(key.length)
    if (region && region.length) {
      if (region.toLowerCase() === 'global_village') {
        region = t('explorer_266')
      } else {
        region = region.toUpperCase()
      }

      if (item?.label?.endsWith('(%s)')) {
        return item.label.replace('(%s)', `(${region})`)
      }
    }
    if (item) {
      return item.label
    }
    return '-'
  }
  const fromAddress = useMemo(() => {
    if (props?.from_address === 'coinbase') {
      return t('explorer_252')
    }
    return props?.from_address
  }, [props])

  const notJumpAddress = useMemo(() => {
    if (props?.from_address === 'coinbase' || params.address === props?.from_address) {
      return true
    }
    return false
  }, [props])

  const getLeftKuohao = () => {
    if (curReponsive?.size === 'mobile') {
      return '('
    }
    return '（'
  }

  const getRightKuohao = () => {
    if (curReponsive?.size === 'mobile') {
      return ')'
    }
    return '）'
  }

  return (
    <div className={classNames(styles.wrap, 'common-box-shadow')}>
      <div className="account_m_area_a">
        {/* 类型 */}
        <div className={styles.title}>{t('explorer_104')}</div>
        <div className={classNames(styles.textStyleTwo, 'font_14')}>{getTag(props?.tag)}</div>
      </div>
      <div className="account_m_area_b">
        {/* 区块 */}
        <div className={styles.title}>{t('explorer_3')}</div>
        <div
          className={classNames(styles.textStyleOne, 'font_14')}
          onClick={() => {
            navigate(`/blockchain/${props?.height}`)
          }}
        >
          {props?.height}
        </div>
      </div>
      <div className="account_m_area_c">
        {/* 从 */}
        <div className={styles.title}>{t('explorer_106')}</div>
        <div className={classNames(styles.textStyleOne, 'font_14')}>
          {notJumpAddress ? (
            <AddressHash
              textStyle={{
                color: '#000',
                cursor: 'auto',
              }}
              data={fromAddress}
              cutOption
              copyIcon={props?.from_address !== 'coinbase' ? 'gray' : false}
            ></AddressHash>
          ) : (
            <AddressHash
              data={fromAddress}
              cutOption
              copyIcon={props?.from_address !== 'coinbase' ? 'gray' : false}
              handleJump={() => {
                if (params.address === props?.from_address) return
                handleAddressJump(props?.from_address, navigate)
                // navigate(`/accountDetail/${props?.from_address}`, { replace: true })
              }}
            ></AddressHash>
          )}
        </div>
      </div>
      {/* <div
        className={classNames({
          [styles.toIcon]: true,
          ['area_d']: true,
        })}
      >
        <span className={styles.to}></span>
      </div> */}
      <div className="account_m_area_e">
        {/* 到 */}
        <div className={styles.title}>{t('explorer_107')}</div>
        <div className={classNames(styles.textStyleOne, 'font_14')}>
          {params.address === props?.to_address ? (
            <AddressHash
              textStyle={{
                color: '#000',
                cursor: 'auto',
              }}
              data={props?.to_address}
              cutOption
              copyIcon={props?.to_address !== 'coinbase' ? 'gray' : false}
            ></AddressHash>
          ) : (
            <AddressHash
              data={props?.to_address}
              cutOption
              copyIcon={props?.to_address !== 'coinbase' ? 'gray' : false}
              handleJump={() => {
                if (params.address === props?.to_address) return
                handleAddressJump(props?.to_address, navigate)
                // navigate(`/accountDetail/${props?.to_address}`)
              }}
            ></AddressHash>
          )}
        </div>
      </div>
      <div className="account_m_area_f">
        {/* 数量 */}
        <div className={styles.title}>{t('explorer_105')}</div>
        <div className={classNames('font_14')}>
          {geaAmount.sigin && (
            <>
              <div className={classNames('font_14')}>
                <span className="font_14">{geaAmount.value}</span>{' '}
                <span
                  className={classNames({
                    [styles.textStyleThree]: true,
                    font_14: true,
                  })}
                >
                  {geaAmount.sigin}
                </span>
              </div>
            </>
          )}
          {gagAmount.sigin && (
            <>
              <div>
                <span className="font_14">{gagAmount.value}</span>{' '}
                <span
                  className={classNames({
                    [styles.textStyleThree]: true,
                    font_14: true,
                  })}
                >
                  {gagAmount.sigin}
                </span>
              </div>
            </>
          )}
          {!gagAmount.sigin && !geaAmount.sigin && <div className={styles.textStyleTwo}>-</div>}
        </div>
      </div>
      <div className="account_m_area_g">
        {/* 时间戳 */}
        <div className={styles.title}>{t('explorer_92')}</div>
        <div className={classNames(styles.textStyleFive, 'font_14')}>
          <div className={classNames(styles.textStyleTwo, 'font_14')}>
            <span style={{ marginRight: '0px' }}>{timeUtc0}</span>
            <span className={classNames(styles.textStyleThree, 'font_14')}>
              {getLeftKuohao()}UTC+0{getRightKuohao()}
            </span>
          </div>
          <div className={classNames(styles.textStyleTwo, 'font_14')}>
            <span style={{ whiteSpace: 'nowrap', marginRight: '0px' }}>{currentTime}</span>
            <span className={classNames(styles.textStyleThree, 'font_14')}>
              {getLeftKuohao()}
              {t('explorer_95')}
              {getRightKuohao()}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(CoduleAccountTrading)
